import React from 'react';
import { Box } from '@mui/material';
import ProjectFileListContainer from '../../../containers/projectmng/files/ProjectFileListContainer';
import ProjectMultiFileFormContainer from '../../../containers/projectmng/files/ProjectMultiFileFormContainer';

const ProjectFileTemplate = () => {
  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      <ProjectFileListContainer />
      <ProjectMultiFileFormContainer />
    </Box>
  );
};

export default ProjectFileTemplate;
